import { LoggingService } from "../../logging.service";
import { Injectable } from "@angular/core";
import { IUiLoggerPayload } from "../../logging.model";

@Injectable()
export class ClickLoggerService {

  constructor(private logger: LoggingService) {}

  // Tell Angular we handle plain 'click' events
  supports(eventName: string): boolean {
    return eventName === 'click';
  }

  // Called whenever Angular fires up a (click) or @HostListener('click')
  addEventListener(
    element: HTMLElement,
    eventName: string,
    handler: Function,
  ): Function {
    const wrapped = (event: Event) => {
      const el = event.target instanceof HTMLElement ? event.target : element;
      if (!el || typeof el.getAttribute !== 'function') {
        handler(event);
        return;
      }
      const tag = el.tagName?.toLowerCase();
      const text = el.getAttribute('aria-label') || el.innerText?.trim()?.substring(0, 50) || 'Unknown';
      const id = el.id || undefined;
      const classes = (typeof el.className === 'string') ? el.className : undefined;

      this.logUi({
        context: "CLICK",
        element: el,
        tag,
        text,
        id,
        classes,
      });

      // 2) call the real handler
      handler(event);
    };

    // This is what DomEventsPlugin basically does internally
    element.addEventListener(eventName, wrapped);

    // Cleanup when Angular destroys the listener
    return () => element.removeEventListener(eventName, wrapped);
  }

  addGlobalEventListener(element: string, eventName: string, handler: Function): Function {
    const wrapped = (event: Event) => {
      //call the real handler
      //nothing to do, as we don't care about this for now, its just needed for the eventManager.
      handler(event);
    };
    return wrapped;
  }

  /**
   * internal function to log the click event.
   * @param element clickable element information
   */
  protected logUi(element: IUiLoggerPayload) {
    this.logger.logUi(element);
  }



}
